import React, { useState } from 'react';
import { Form, Button, FormGroup, Input, Label, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { authorizedUpload } from '../api-authorization/AuthorizedFetch';

export const ImportClassDataModalButton = ({ schoolId, children }) => {
  const [modalState, setModalState] = useState(false);
  
  const toggleImport = () => setModalState(!modalState);

  return (
    <>
      <Button onClick={toggleImport} color="primary">{children}</Button>
      <ImportClassDataModal isOpen={modalState} schoolId={schoolId} toggle={toggleImport} />
    </>
  );
};



const ImportClassDataModal = ({ schoolId, isOpen, toggle }) => {
  const [file, setFile] = useState(null);


  // todo - default to null if file isnt there?
  // eric: I don't know what else to default to, but it looks like it would've defaulted to null either way
  const fileChanged = e => setFile(e?.target?.files?.[0] || null);

  const importData = async () => {
    const data = new FormData();
    data.append("file", file);

    const response = await authorizedUpload(`api/schools/${schoolId}/import`, data);
    console.log(response);

    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        Import Class Data
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label>File</Label>
            <Input type="file" onChange={fileChanged} />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={importData}
          disabled={file == null ? 'disabled' : null }
        >
          Import
        </Button>
        <Button onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ImportClassDataModal;